export default "__VITE_ASSET__DVZBNrm___"